import { create } from 'zustand';
import { MicPermissionStoreType } from '../types/store/mic-permission.types';

export const useMicPermissionStore = create<MicPermissionStoreType>((set) => ({
  micPermissionDenied: false,
  setMicPermissionDenied: (micPermissionDenied) => set({ micPermissionDenied }),
}));
